import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
// 原簿閲覧請求更新
import {
  IAPI_INQ005_Request,
  IAPI_INQ005_Response,
} from "../../../type/apiType";
// 職員照会各種請求参照
import {
  IAPI_INQ006_Request,
  IAPI_INQ006_Response,
} from "../../../type/apiType";

// 職員照会各種請求参照API
const httpAPI_INQ006 = async (
  param: IAPI_INQ006_Request
): Promise<IAPI_INQ006_Response> => {
  let res = await http.post(ApiUrl.API_INQ006, {
    ...param,
  });

  return res.data;
};

// 原簿閲覧請求更新API
const httpAPI_INQ005 = async (
  param: IAPI_INQ005_Request
): Promise<IAPI_INQ005_Response> => {
  let res = await http.post(ApiUrl.API_INQ005, {
    ...param,
  });

  return res.data;
};

export { httpAPI_INQ006, httpAPI_INQ005 };
